module.exports = __webpack_public_path__ + "static/media/hokodo.aa04f3ea.svg";